import React from "react";
import styled, { css } from "styled-components";
import { Alert, Badge } from "components/bootstrap";
import { Spinner } from "components/common";
import useWorkflowRequiredPermissions from "aiagent/AgentWorkflows/hooks/useWorkflowRequiredPermissions";
const PermissionList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacings.xxs};
  `
);
const WorkflowRequiredPermissions = ({ workflowId }) => {
  const { data: permissions, isLoading, isError, error } = useWorkflowRequiredPermissions(workflowId);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading permissions..." });
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Failed to load permissions" }, error instanceof Error ? error.message : "Unknown error");
  }
  if (!(permissions == null ? void 0 : permissions.length)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "No permissions required");
  }
  return /* @__PURE__ */ React.createElement(PermissionList, null, permissions.map((permission) => /* @__PURE__ */ React.createElement(Badge, { bsStyle: "default", key: permission }, permission)));
};
export default WorkflowRequiredPermissions;
